<template>
    <div v-if="loadingFlag">
        <div class="ajaxLoading"></div>
        <div class="text-tip">{{loadingText}}</div>
    </div>
</template>

<script>
    export default {
        name: "loading",
        data() {
            return {
                loadingFlag: false,
                loadingText:""
            }
        },
        watch:{
            loadingText() {
                this.loadingFlag = !!this.loadingText;
            },
            loadingFlag() {
                if (!this.loadingFlag) {
                    this.loadingText = "";
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .ajaxLoading {
        display: block;
        position: fixed;
        width: 100%;
        height: 45%;
        background: url("../../../assets/img/loading.gif") 50% 99% no-repeat;
        background-size: 44px;
        left: 0;
        top: 0;
        z-index: 2000;
    }
    .text-tip {
        display: block;
        position: fixed;
        width: 100%;
        height: 55%;
        bottom: 0;
        z-index: 2000;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// loading.vue?cd4a37a8